import { render } from "./SimpleWidget.vue?vue&type=template&id=50959d46&scoped=true"
import script from "./SimpleWidget.vue?vue&type=script&lang=js"
export * from "./SimpleWidget.vue?vue&type=script&lang=js"

import "./SimpleWidget.vue?vue&type=style&index=0&id=50959d46&scoped=true&lang=css"

import exportComponent from "/home/mw/Code/hc-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50959d46"]])

export default __exports__